import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2, Compass, AlertTriangle } from 'lucide-react';

export default function DemoLaunchPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithMagicToken } = useAuth();
  const [error, setError] = useState(null);
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    const token = params.get('token');
    if (!token) { setError('This link is missing its access token.'); return; }
    (async () => {
      try {
        localStorage.removeItem('demo_tour_done');
        localStorage.setItem('demo_tour_step', '0');
        const userData = await loginWithMagicToken(token);
        if (userData?.lead_id) localStorage.setItem('demo_lead_id', userData.lead_id);
        navigate('/', { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || 'This demo link could not be opened.');
      }
    })();
  }, [params, loginWithMagicToken, navigate]);

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6" data-testid="demo-launch-page">
      <div className="text-center max-w-md">
        {error ? (
          <div data-testid="demo-launch-error">
            <AlertTriangle className="w-10 h-10 text-amber-400 mx-auto mb-4" />
            <p className="font-bold text-xl">Demo link problem</p>
            <p className="text-white/60 mt-2">{error}</p>
            <Link to="/demo" className="inline-block mt-6 bg-teal-400 text-slate-950 font-bold px-6 py-3 rounded-full hover:bg-teal-300" data-testid="demo-launch-request-again">
              Request access again
            </Link>
          </div>
        ) : (
          <div data-testid="demo-launch-loading">
            <Compass className="w-10 h-10 text-teal-400 mx-auto mb-4" />
            <p className="font-bold text-xl inline-flex items-center gap-2"><Loader2 className="w-5 h-5 animate-spin" /> Opening your live demo…</p>
            <p className="text-white/50 mt-2 text-sm">Signing you in — the guided tour will start automatically.</p>
          </div>
        )}
      </div>
    </div>
  );
}
